import { createFileRoute } from "@tanstack/react-router";
import DeadlineCalendarPage from "@/features/public/pages/tools/deadline-calendar";

export const Route = createFileRoute("/(public)/_public/tools/deadline-calendar")({
  component: DeadlineCalendarPage,
});
